import { Option } from "@familyzone/component-library";
import { useObjectStore } from "../../../storez/ObjectStore";

export const getWebsiteObjects = (): Option[] => {
  const websiteObjects = useObjectStore.getState().getWebsiteObjects();
  return websiteObjects.map((websiteObject) => ({
    value: websiteObject.id || "",
    label: websiteObject.name,
  }));
};
